import ApiService from "@Src/services/learning/ApiService";
import { APIEnv } from "@Src/services/learning/baseInterfaces";

export async function getData(
  endPoint: string,
  queryParams: object = {},
  urlParam: any,
  APIEnvironment: APIEnv
) {
  return await ApiService.fetchData(
    {
      url: urlParam ? endPoint + "/" + urlParam : endPoint,
      method: "get",
      params: queryParams,
    },
    APIEnvironment
  );
}
export async function postData(
  endPoint: string,
  data: any,
  APIEnvironment: APIEnv,
  method: string = "post",
  customHeaders?: any,
  queryParams?: object
) {
  return await ApiService.fetchData(
    {
      url: endPoint,
      method: method,
      data: data,
      ...(queryParams && { params: queryParams }),
    },
    APIEnvironment,
    customHeaders
  );
}
export async function getDataWithpayload(
  endPoint: string,
  queryParams: object = {},
  urlParam: any,
  APIEnvironment: APIEnv
  //   data: any
) {
  return await ApiService.fetchData(
    {
      url: urlParam ? endPoint + "/" + urlParam : endPoint,
      method: "get",
      params: queryParams,
      //   data: data,
    },
    APIEnvironment
  );
}
